<template>
  <hic-dialog append-to-body :close-on-click-modal="false" title="住院通知单" @open="page" :visible="visible" @close="close" width="70rem">
    <el-row style="padding: 0 2rem">
      <el-row type="flex" justify="center">
        <!-- <dict-select dict-type="patientType" style="width: auto" isEnum></dict-select> -->
        <el-date-picker size="small" class="left-pad" v-model="condition.DateTime" type="datetime" value-format="yyyy-MM-dd" placeholder="通知日期"></el-date-picker>
        <el-input style="width: 17rem" class="condition-wide left-pad" v-model="condition.keyword" placeholder="姓名、证件号码、住院通知单号" size="small" v-on:keyup.enter.native="page" clearable>
          <el-button type="info" :loading="meta.loading" @click.native="page" slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <el-button class="left-pad" type="info" size="small">身份证读卡</el-button>
      </el-row>
      <div>
        <el-table :data="entities.items" style="width: 100%" v-loading="meta.loading">
          <el-table-column label="操作" align="center" width="100">
            <template slot-scope="{ row }">
              <el-button title="确认" type="primary" plain circle size="mini" icon="el-icon-check" @click="register(row)"></el-button>
              <el-button title="废弃" type="danger" plain circle size="mini" icon="el-icon-close" @click="cancel(row)"></el-button>
            </template>
          </el-table-column>

          <el-table-column prop="patientName" label="患者姓名" align="center" width="100"></el-table-column>
          <el-table-column prop="ipDeptCode" label="入住科室" align="right" width="120">
            <template slot-scope="{ row }">
              {{ row.ipDeptCode | dictText("Dept") }}
            </template>
          </el-table-column>
          <el-table-column prop="deptCode" label="门诊科室" align="right" width="120">
            <template slot-scope="{ row }">
              {{ row.deptCode | dictText("Dept") }}
            </template>
          </el-table-column>
          <el-table-column prop="doctorName" label="门诊医生" align="center" width="100"></el-table-column>
          <el-table-column prop="criticalLevel" width="100" align="center" label="危重等级"></el-table-column>

          <el-table-column prop="noticeDate" width="100" align="center" label="通知日期">
            <template slot-scope="{ row }">
              {{ row.noticeDate | fmtDate }}
            </template>
          </el-table-column>
          <el-table-column prop="memo" min-width="50" label="备注" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>

      <!-- <el-empty v-else description="暂无数据"></el-empty> -->
    </el-row>
    <hospitalization-editor create v-model="hosp" :visible.sync="meta.editorShow" @saved="hospSaved"></hospitalization-editor>
    <div slot="footer">
      <el-button type="info" @click="$emit('update:visible', false)">关闭</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      // shistory: () => import("./shistory"),
      "hospitalization-editor": () => import("./dlg_hospitalization_edit"),
    },
    props: {
      title: String,
      infoDetail: Object,
      visible: Boolean,
    },
    data() {
      return {
        hosp: {},
        meta: {
          editorShow: false,
          loading: false,
        },
        entities: {
          items: [],
        },
        condition: {
          nulls: "ipNo",
          disabled: false,
          keyword: "",
          pageSize: 10,
          sort: "id",
          asc: false,
        },
      };
    },
    computed: {
      ...mapGetters(["dict", , "Enum", "dictEnum", "user", "permission"]),
    },
    mounted() {
      this.page();
    },
    methods: {
      page() {
        this.meta.loading = true;
        api.IpNotice.query(this.condition)
          .then((res) => {
            this.entities.items = res.items;
          })
          .catch((err) => {
            this.$message.error(err);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      close() {
        this.$emit("update:visible", false);
      },
      register(row) {
        api.Hospitalization.query({
          patientCode: row.patientCode,
          states: [this.Enum.HospitalizationState.已登记, this.Enum.HospitalizationState.已入住, this.Enum.HospitalizationState.已结算],
        }).then((res) => {
          if (res.items.length) {
            this.$message.warning("当前患者处于在院状态，无法重复办理入院！");
            return;
          }
          this.hosp = {
            opNo: row.opNo,
            patientCode: row.patientCode,
            patientName: row.patientName,
            opDeptCode: row.deptCode,
            opDocotrId: row.doctorCode,
            opDoctorName: row.doctorName,
            originalDeptCode: row.ipDeptCode,
            deptCode: row.ipDeptCode,
            critcalLevel: row.critcalLevel,
            diagnosisCode: row.diagnosisCode,
            diagnosisName: row.diagnosisName,
            state: this.Enum.HospitalizationState.已登记,
            ipType: null,
            stayTimes: 1,
            comeFrom: row.ifEmergency ? "2" : "1", // 门诊（需要固定字典项）
            stayType: "1", // 住院病人（需要固定字典项）
          };
          // 计算住院次数
          api.Hospitalization.getStayTimes(row.patientCode).then((res) => {
            this.hosp.stayTimes = res + 1;
          });
          this.meta.editorShow = true;
        });
      },
      cancel(row) {},
      hospSaved(hosp) {
        this.hosp.ipNo = hosp.ipNo;
        api.IpNotice.save(this.hosp);
        this.page();
      },
    },
  };
</script>

<style scoped></style>
